/* <![CDATA[ */
/*global $:false */
jQuery(document).ready(function() {

    "use strict";

    // interior banners parallax functions
    var $IBparallax = jQuery('.interior-banner .image');
    if ($IBparallax.length) {
        var yPos = jQuery(window).scrollTop();
        $IBparallax.css({ "transform": "translate3d(0px, " + yPos + "px, 0px)" });
        jQuery(window).scroll(function() {
            var yPos = jQuery(window).scrollTop();
            $IBparallax.css({ "transform": "translate3d(0px, " + yPos + "px, 0px)" });
        });
    }

    // search functions
    jQuery('.toggle-search').click(function(ev){
        ev.stopPropagation();
        if (jQuery(this).parents('.search-form').hasClass('active')) {
            jQuery(this).parents('.search-form').removeClass('active');
        } else {
            jQuery(this).parents('.search-form').addClass('active');
        }
    });
    jQuery('.search-form-ct').click(function(ev) {
        ev.stopPropagation();
    });
    jQuery('body').click(function() {
        jQuery('.search-form').removeClass('active');
    });
	jQuery( '.search_term' ).click( function () {
		jQuery( '.field' ).val( jQuery( this).text() );
		jQuery( '.search-form form' ).trigger( 'submit' );
	});

    // mobile search functions
    jQuery('.show-mobile-search').click(function(ev){
        ev.stopPropagation();
        if (jQuery(this).parents('.mobile-search-form').hasClass('active')) {
            jQuery(this).parents('.mobile-search-form').removeClass('active');
            var val = jQuery(this).siblings('form').find('.field').val();
            if (val !== '') {
                jQuery(this).siblings('form').submit();
            };
        } else {
            jQuery(this).parents('.mobile-search-form').addClass('active');
        }
    });
    jQuery('.mobile-search-form .field').click(function(ev) {
        ev.stopPropagation();
    });
    jQuery('body').click(function() {
        jQuery('.mobile-search-form').removeClass('active');
    });

    /* share functions */
    jQuery('.show-share-list').click(function(ev){
        ev.preventDefault();
        ev.stopPropagation();
        if ( jQuery(this).hasClass('active')) {
            jQuery(this).removeClass('active');
            jQuery(this).siblings('.share-list').animate({opacity: 'hide', height: 'hide'}, 700, 'easeOutQuint');
        } else {
            jQuery(this).addClass('active');
            jQuery(this).siblings('.share-list').animate({opacity: 'show', height: 'show'}, 700, 'easeOutQuint');
        }
    });
    jQuery('body').click(function(){
        if ( jQuery('.show-share-list').hasClass('active')) {
            jQuery('.show-share-list').removeClass('active');
            jQuery('.share-list').animate({opacity: 'hide', height: 'hide'}, 700, 'easeOutQuint');
        }
    });
    jQuery('.share-list').click(function(ev) {
        ev.stopPropagation();
    });

    /* main-menu */
    jQuery('.show-second-submenu').click(function(ev){
        ev.preventDefault();
        if ( jQuery(this).hasClass('active')) {
            jQuery(this).removeClass('active');
            jQuery(this).siblings('.second-submenu').animate({opacity: 'hide', height: 'hide'}, 700, 'easeOutQuint');
        } else {
            jQuery(this).parents('li').siblings('li').each(function(){
                if (jQuery(this).find('.show-second-submenu').hasClass('active')) {
                    jQuery(this).find('.show-second-submenu').removeClass('active');
                    jQuery(this).find('.second-submenu').animate({opacity: 'hide', height: 'hide'}, 700, 'easeOutQuint');
                }
            });
            jQuery(this).addClass('active');
            jQuery(this).siblings('.second-submenu').animate({opacity: 'show', height: 'show'}, 700, 'easeOutQuint');
        }
    });

    /* mobile-menu */
    jQuery('.toggle-mobile-menu').click(function(ev){
        ev.stopPropagation();
        if ( jQuery(this).hasClass('active')) {
            jQuery(this).removeClass('active');
            jQuery('body').removeClass('mobile-menu-active');
            jQuery(this).find('.top-bar').removeClass('rotate');
            jQuery(this).find('.top-bar').removeClass('middle');
            jQuery(this).find('.bottom-bar').removeClass('rotate');
            jQuery(this).find('.bottom-bar').removeClass('middle');

        } else {
            jQuery(this).addClass('active');
            jQuery('body').addClass('mobile-menu-active');
            jQuery(this).find('.top-bar').addClass('middle');
            jQuery(this).find('.top-bar').addClass('rotate');
            jQuery(this).find('.bottom-bar').addClass('middle');
            jQuery(this).find('.bottom-bar').addClass('rotate');
        }
    });
    jQuery('body').click(function(){
        jQuery('.toggle-mobile-menu').removeClass('active');
        jQuery('body').removeClass('mobile-menu-active');
        jQuery('.toggle-mobile-menu .top-bar').removeClass('rotate');
        jQuery('.toggle-mobile-menu .top-bar').removeClass('middle');
        jQuery('.toggle-mobile-menu .bottom-bar').removeClass('rotate');
        jQuery('.toggle-mobile-menu .bottom-bar').removeClass('middle');
    });
    jQuery('.mobile-menu').click(function(ev) {
        ev.stopPropagation();
    });
    jQuery('.show-submenu').click(function(ev){
        ev.preventDefault();
        if ( jQuery(this).hasClass('active')) {
            jQuery(this).removeClass('active');
            jQuery(this).siblings('.submenu').animate({opacity: 'hide', height: 'hide'}, 700, 'easeOutQuint');
        } else {
            jQuery(this).parents('li').siblings('li').each(function(){
                if (jQuery(this).find('.show-submenu').hasClass('active')) {
                    jQuery(this).find('.show-submenu').removeClass('active');
                    jQuery(this).find('.submenu').animate({opacity: 'hide', height: 'hide'}, 700, 'easeOutQuint');
                }
            });
            jQuery(this).addClass('active');
            jQuery(this).siblings('.submenu').animate({opacity: 'show', height: 'show'}, 700, 'easeOutQuint');
        }
    });
    jQuery('.show-megamenu').click(function(ev){
        ev.preventDefault();
        if ( jQuery(this).hasClass('active')) {
            jQuery(this).removeClass('active');
            jQuery(this).siblings('.megamenu').removeClass('active');
        } else {
            jQuery(this).addClass('active');
            jQuery(this).siblings('.megamenu').addClass('active');
        }
    });
    jQuery('.megamenu .back').click(function(ev){
        jQuery('.show-megamenu').removeClass('active');
        jQuery('.megamenu').removeClass('active');
    });
    jQuery('.mobile-menu .column h3').click(function(ev){
        ev.preventDefault();
        if ( jQuery(this).hasClass('active')) {
            jQuery(this).removeClass('active');
            jQuery(this).siblings('ul').animate({opacity: 'hide', height: 'hide'}, 700, 'easeOutQuint');
        } else {
            jQuery(this).parents('.column').siblings('.column').each(function(){
                if (jQuery(this).find('h3').hasClass('active')) {
                    jQuery(this).find('h3').removeClass('active');
                    jQuery(this).find('ul').animate({opacity: 'hide', height: 'hide'}, 700, 'easeOutQuint');
                }
            });
            jQuery(this).addClass('active');
            jQuery(this).siblings('ul').animate({opacity: 'show', height: 'show'}, 700, 'easeOutQuint');
        }
    });

    /* styling selects */
    jQuery('select').selectize();

    // back to top
    jQuery('.back-to-top').click(function(){
        jQuery("html, body").animate({scrollTop: 0}, 300);
    });

    // responsive tables
    jQuery(window).on('load', function(){
        jQuery('.wysiwyg table').each(function(){
            jQuery(this).wrap('<div class="table-holder"></div>').promise().done(function(){
                jQuery(this).parent('.table-holder').append('<span class="msg">Swipe horizontally to view all fields.</span>');
            });
            var Twidth = jQuery(this).width();
            var Pwidth = jQuery(this).parent('.table-holder').width();
            if (Pwidth < Twidth) {
                jQuery(this).parent('.table-holder').find('.msg').show();
            } else {
                jQuery(this).parent('.table-holder').find('.msg').hide();
            }
        });
    });
    jQuery(window).on('resize', function(){
        jQuery('.wysiwyg table').each(function(){
            var Twidth = jQuery(this).width();
            var Pwidth = jQuery(this).parent('.table-holder').width();
            if (Pwidth < Twidth) {
                jQuery(this).parent('.table-holder').find('.msg').show();
            } else {
                jQuery(this).parent('.table-holder').find('.msg').hide();
            }
        });
    });

    // mobile-related functions
    jQuery('.toggle-mobile-related').click(function(ev){
        ev.stopPropagation();
        if ( jQuery(this).hasClass('active')) {
            jQuery(this).removeClass('active');
            jQuery('.related-items').animate({height: 'hide'}, 700, 'easeOutQuint');
            jQuery(this).find('.top-line').removeClass('rotate');
            jQuery(this).find('.top-line').removeClass('middle');
            jQuery(this).find('.bottom-line').removeClass('rotate');
            jQuery(this).find('.bottom-line').removeClass('middle');
        } else {
            jQuery(this).addClass('active');
            jQuery('.related-items').animate({height: 'show'}, 700, 'easeOutQuint');
            jQuery(this).find('.top-line').addClass('middle');
            jQuery(this).find('.top-line').addClass('rotate');
            jQuery(this).find('.bottom-line').addClass('middle');
            jQuery(this).find('.bottom-line').addClass('rotate');
        }
    });

    // sort item functions
    jQuery('.sort-item .sort-item-top').click(function(){
        if ( jQuery(this).hasClass('active')) {
            jQuery(this).removeClass('active');
            jQuery(this).siblings('.sort-item-list').animate({opacity: 'hide', height: 'hide'}, 700, 'easeOutQuint');
        } else {
            jQuery(this).parents('li').siblings('li').each(function(){
                if (jQuery(this).find('.sort-item-top').hasClass('active')) {
                    jQuery(this).find('.sort-item-top').removeClass('active');
                    jQuery(this).find('.sort-item-list').animate({opacity: 'hide', height: 'hide'}, 700, 'easeOutQuint', function () {});
                }
            });
            jQuery(this).addClass('active');
            jQuery(this).siblings('.sort-item-list').animate({opacity: 'show', height: 'show'}, 700, 'easeOutQuint');
        }
    });
    jQuery('body').click(function(){
        jQuery('.sort-item').each(function(){
            if (jQuery(this).find('.sort-item-top').hasClass('active')) {
                jQuery(this).find('.sort-item-top').removeClass('active');
                jQuery(this).find('.sort-item-list').animate({opacity: 'hide', height: 'hide'}, 700, 'easeOutQuint', function () {});
            }
        });
    });
    jQuery('.sort-item').click(function(ev) {
        ev.stopPropagation();
    });

    // dropdown functions
    jQuery('.dropdown .dropdown-top').click(function(){
        if ( jQuery(this).hasClass('active')) {
            jQuery(this).removeClass('active');
            jQuery(this).siblings('.dropdown-content').animate({opacity: 'hide', height: 'hide'}, 700, 'easeOutQuint');
        } else {
            jQuery(this).parents('li').siblings('li').each(function(){
                if (jQuery(this).find('.dropdown-top').hasClass('active')) {
                    jQuery(this).find('.dropdown-top').removeClass('active');
                    jQuery(this).find('.dropdown-content').animate({opacity: 'hide', height: 'hide'}, 700, 'easeOutQuint', function () {});
                }
            });
            jQuery(this).addClass('active');
            jQuery(this).siblings('.dropdown-content').animate({opacity: 'show', height: 'show'}, 700, 'easeOutQuint');
        }
    });
    jQuery('body').click(function(){
        jQuery('.dropdown').each(function(){
            if (jQuery(this).find('.dropdown-top').hasClass('active')) {
                jQuery(this).find('.dropdown-top').removeClass('active');
                jQuery(this).find('.dropdown-content').animate({opacity: 'hide', height: 'hide'}, 700, 'easeOutQuint', function () {});
            }
        });
    });
    jQuery('.dropdown').click(function(ev) {
        ev.stopPropagation();
    });

    // home rotator functions
    jQuery('.home-rotator .slides').slick({
        speed: 500,
        fade: true,
        arrows: false,
        autoplay: true,
        autoplaySpeed: 6000,
        pauseOnHover: false,
        dots: true,
        appendDots: '.caption'
    });
    jQuery('.home-rotator .slide').each(function(){
        var $HRparallax = jQuery(this).find('.image');
        var yPos = jQuery(window).scrollTop() / 5;
        $HRparallax.css({ "transform": "translate3d(0px, " + yPos + "px, 0px)" });
        jQuery(window).scroll(function() {
            var yPos = jQuery(window).scrollTop() / 5;
            $HRparallax.css({ "transform": "translate3d(0px, " + yPos + "px, 0px)" });
        });
    });
    jQuery('.slick-dots button').click(function(){
		mainRotatorDots( jQuery(this).parent('li').index() );
    });
	// On before slide change
	jQuery('.home-rotator .slides').on('beforeChange', function(event, slick, currentSlide, nextSlide){
		mainRotatorDots( nextSlide );
	});
    // home rotator functions
    // jQuery('.clients-slides ul').slick({
    //     speed: 500,
    //     arrows: false,
    //     autoplay: true,
    //     autoplaySpeed: 5000,
    //     pauseOnHover: false,
    //     dots: false,
    //     slidesToShow: 4,
    //     slidesToScroll: 4,
    //     responsive: [
    //         {
    //           breakpoint: 991,
    //           settings: {
    //             slidesToShow: 3,
    //             slidesToScroll: 3,
    //             arrows: false
    //           }
    //         },
    //         {
    //           breakpoint: 767,
    //           settings: {
    //             slidesToShow: 2,
    //             slidesToScroll: 2,
    //             arrows: false
    //           }
    //         },
    //         {
    //           breakpoint: 576,
    //           settings: {
    //             slidesToShow: 1,
    //             slidesToScroll: 1,
    //             arrows: false
    //           }
    //         }
    //     ]
    // });

    // stories functions
    jQuery('.contact-top .slides').slick({
        speed: 500,
        arrows: false,
        infinite: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        dots: true,
        customPaging : function(slider, i) {
            var title = jQuery(slider.$slides[i]).attr('title');
            return '<span class="pager__item"> '+title+' </span>';
        }
    });

    // clients-bottom functions
    jQuery('.clients-bottom  .slides').slick({
        speed: 500,
        fade: true,
        arrows: false,
        autoplay: true,
        autoplaySpeed: 6000,
        pauseOnHover: false,
        dots: true,
		dotsClass: 'slick-dots-testimonial'
    });
    jQuery(window).on('load', function(){
        if (jQuery('.clients-bottom').length) {
            jQuery('.clients-bottom .bg-image').css('top', - jQuery(window).height() / 5 +'px');
            if (isAppearIntoView(jQuery('.clients-bottom'))) {
                var $Uparallax = jQuery('.clients-bottom .bg-image');
                var UparallaxTop = jQuery('.clients-bottom').offset().top;
                var winHeight = jQuery(window).height();
                var yPos = (jQuery(window).scrollTop() - (UparallaxTop - winHeight)) / 5;
                $Uparallax.css({ "transform": "translate3d(0px, " + yPos + "px, 0px)" });
            }
        }
    });
    jQuery(window).on('scroll', function(){
        if (jQuery('.clients-bottom').length) {
            if (isAppearIntoView(jQuery('.clients-bottom'))) {
                var $Uparallax = jQuery('.clients-bottom .bg-image');
                var UparallaxTop = jQuery('.clients-bottom').offset().top;
                var winHeight = jQuery(window).height();
                var yPos = (jQuery(window).scrollTop() - (UparallaxTop - winHeight)) / 5;
                $Uparallax.css({ "transform": "translate3d(0px, " + yPos + "px, 0px)" });
            }
        }
    });
    jQuery(window).on('resize', function(){
        jQuery('.clients-bottom .bg-image').css('top', - jQuery(window).height() / 5 +'px');
    });

    // reveal functions
    if (jQuery('.reveal').length) {
        jQuery('.reveal').each(function(){
            if (isIntoView(jQuery(this)) && !jQuery(this).hasClass('animate')) {
                jQuery(this).addClass('animate');
            }
        });
    }
    jQuery(window).scroll(function() {
        if (jQuery('.reveal').length) {
            jQuery('.reveal').each(function(){
                if (isIntoView(jQuery(this)) && !jQuery(this).hasClass('animate')) {
                    jQuery(this).addClass('animate');
                }
            });
        }
    });

	// Init jQuery UI accordions
	jQuery( '.accordion,.accordion-styled' ).accordion( {
		collapsible: true,
		active: false,
		heightStyle: 'content'
	});

});

function isAppearIntoView(elem)
{
    if (jQuery(elem).length) {
        var docViewTop = jQuery(window).scrollTop();
        var docViewBottom = docViewTop + jQuery(window).height();

        var elemTop = jQuery(elem).offset().top;
        var elemHeight = jQuery(elem).outerHeight();
        var elemBottom = elemTop + elemHeight;
    }

    return (elemTop <= docViewBottom && elemBottom >= docViewTop);
}

function isIntoView(elem)
{
    if (elem.length) {
        var docViewTop = jQuery(window).scrollTop();
        var docViewBottom = docViewTop + jQuery(window).height();
        var elemTop = jQuery(elem).offset().top;
        var elemHeight = jQuery(elem).outerHeight();
        var elemBottom = elemTop + elemHeight;
        return (elemBottom <= docViewBottom);
    }
}
// Set the index of the Main Rotator Dots.
function mainRotatorDots( index ) {
	jQuery('.slick-dots li').removeClass('psactive');
	jQuery('.slick-dots').each(function(){
		jQuery(this).children('li:eq('+index+')').addClass('psactive');
	});
}
